import React from "react";
import styles from "./EntitlementResult.module.scss";
import { EntitlementResultType } from "types";
import SvgGenerator from "components/svgGenerator/SvgGenerator";
import Text from "components/text/Text";
import strings from "assets/strings";
import settings from "assets/mergeSettings";

export const EntitlementResult = ({ hit }: { hit: EntitlementResultType }) => {

  return (

    <a href={`${settings.zakautServicePage}?sid=${hit.serviceId}`} className={styles.link}>
      <div className={styles.entitlementDetails}>
        <Text
          className={styles.textServiceName}
          text={hit.serviceName}
        />
        <Text
          className={styles.textEntitlementDesc}
          text={hit.seviceDescClear}
        />
        <div className={styles.entitlementPrices}>
          <div className={styles.price}>
            <span className={styles.salIcon}>
              {hit.zakauts.hasOwnProperty('sal') ? <SvgGenerator className={styles.svg} name="SalZakautChecked" objectName="zakautSearchResults" /> : <SvgGenerator className={styles.svg} name="ZakautDisable" objectName="zakautSearchResults" />}
            </span>
            <div className={hit.zakauts.hasOwnProperty('sal') ? styles.textEnable : styles.textDisable}>
              {hit.zakauts.hasOwnProperty('sal') ? <span className="visually-hidden">קיים</span> : <span className="visually-hidden">לא קיים</span>} {strings.entitlementSearch.healthBasket}
            </div>
          </div>
          <div className={styles.price}>
            <span className={styles.salIcon}>
              {hit.zakauts.hasOwnProperty('silver') ? <SvgGenerator className={styles.svg} name="SilverZakautChecked" objectName="zakautSearchResults" /> : <SvgGenerator className={styles.svg} name="ZakautDisable" objectName="zakautSearchResults" />}
            </span>
            <div className={hit.zakauts.hasOwnProperty('silver') ? styles.textEnable : styles.textDisable}>
              {hit.zakauts.hasOwnProperty('silver') ? <span className="visually-hidden">קיים</span> : <span className="visually-hidden">לא קיים</span>} {strings.entitlementSearch.silverLeumit}
            </div>
          </div>
          <div className={styles.price}>
            <span className={styles.salIcon}>
              {hit.zakauts.hasOwnProperty('golden') ? <SvgGenerator className={styles.svg} name="GoldZakautChecked" objectName="zakautSearchResults" /> : <SvgGenerator className={styles.svg} name="ZakautDisable" objectName="zakautSearchResults" />}
            </span>
            <div className={hit.zakauts.hasOwnProperty('golden') ? styles.textEnable : styles.textDisable}>
              {hit.zakauts.hasOwnProperty('golden') ? <span className="visually-hidden">קיים</span> : <span className="visually-hidden">לא קיים</span>} {strings.entitlementSearch.goldLeumit}
            </div>
          </div>
        </div>
      </div>
    </a>

  );
};
